<div class="bar">
  <img class="img" src="assets/icons/exclamation.svg">
  <div class="msg">{{message}}</div>
</div>